import React from 'react';

import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import { deleteTrekksoftCategory } from 'actions/userSettings';
import { DropDown, ExpansionPanelWrapper } from 'components';

import { useStyles } from './styles';

const initialValues = {
  trekkSoftCategoriesMapping: []
};

const TREKKSOFT_CATEGORIES = [
  'Adult',
  'Senior',
  'Child',
  'Infant',
  'Traveler',
  'Student',
  'Youth',
  'Junior',
  'Military',
  'Other'
];

export const HORN_CATEGORIES = [
  'Adult',
  'Children',
  'Senior',
  'Teen',
  'Infant',
  'Universal'
];

const TrekksoftCategoriesMapping = ({
  deleteCategoriesInfo,
  trekSoftCategoriesMapping
}) => {
  const classes = useStyles();

  const onAddHandler = (fields, id) => {
    fields.push({
      id: id,
      categoryOnTrekksoft: '',
      category: ''
    });
  };

  const onDeleteHandler = item => {
    if (item.isCreated) deleteCategoriesInfo(item.id);
  };

  const onDeleteAllHandler = () => {
    const categories =
      trekSoftCategoriesMapping.values.trekkSoftCategoriesMapping;
    categories.map(item => {
      if (item.isCreated) deleteCategoriesInfo(item.id);
    });
  };

  return (
    <div className={classes.categoriesMappingWrapper}>
      <Typography variant="h2" className={classes.title}>
        Trekksoft participants categories
      </Typography>
      <FieldArray
        name="trekkSoftCategoriesMapping"
        component={ExpansionPanelWrapper}
        isAddDeleteActions={true}
        add={onAddHandler}
        remove={onDeleteHandler}
        removeAll={onDeleteAllHandler}
        getTitle={item => item.categoryOnTrekksoft}
        children={field => (
          <div className={classes.inputRow}>
            <Field
              name={`${field}.categoryOnTrekksoft`}
              className={classes.input}
              list={TREKKSOFT_CATEGORIES}
              label="Trekksoft platform category"
              component={DropDown}
            />
            <Field
              name={`${field}.category`}
              className={classes.input}
              list={HORN_CATEGORIES}
              label="Horn platform category"
              component={DropDown}
            />
          </div>
        )}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deleteCategoriesInfo: id => dispatch(deleteTrekksoftCategory(id))
});

const mapStateToProps = state => ({
  trekSoftCategoriesMapping: state.form.trekkSoftCategoriesMapping
});

export default reduxForm({
  form: 'trekkSoftCategoriesMapping',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(TrekksoftCategoriesMapping));
